import React, { useEffect, useRef, useState } from 'react';

const ChatTutorial = () => {
  const yourElementRef = useRef(null); // Create a ref for your DOM element
  const yourElementRefAdvance = useRef(null); // Create a ref for your DOM element
  // const [counter, setCounter] = useState(0)

  useEffect(() => {
    const checklistId = 3532;
    const checklistIdAdvance = 3649;
    const yourElement = yourElementRef.current; // Access the DOM element
    const yourElementAdvance = yourElementRefAdvance.current; // Access the DOM element
    // console.log(yourElement,"myeme")

    if (yourElement) {
      // Check if the element exists before calling the API
      if (window.productFruits && window.productFruits.api && window.productFruits.api.checklists) {
        // Check if the API structure is available
        window.productFruits.api.checklists.injectToElement(checklistId, yourElement);
        window.productFruits.api.checklists.injectToElement(checklistIdAdvance, yourElementAdvance);
        // setCounter(counter+1)
      } else {
        console.error('productFruits API is not available');
      }
    } else {
      console.error('Element with ref not found');
    }
  }, []); // Run this effect only once when the component mounts

  return <div  className='grid grid-cols-12 gap-6'>
    <div className='col-span-6 overflow-y-auto h-[80vh]' ref={yourElementRef}></div>
    <div className='col-span-6 overflow-y-auto h-[80vh]' ref={yourElementRefAdvance}></div>
  </div>; // Attach the ref to your element
};

export default ChatTutorial;